import React, { Component } from 'react';
import style from './TextBoxWithLabel.module.css';
// import logoImage from '../assets/images/header_logo.svg';
// import MenuLeft from './MenuLeft.js';
//import artwork from '../assets/images/artwork.svg';

class TextBoxWithLabel extends Component {
    render() {
        let value = "";
        if(this.props.value !== null){
            value = this.props.value;
        }
        return (

            <>

                {this.props.readOnly === true &&

                    <div className={style.area_disable}>
                        <div className={style.label}>
                            {this.props.label}
                        </div>

                        <input className={style.tbx_readonly} type="text" id={this.props.id} onChange={this.props.onChange} value={value} name={"do_nothing"} />

                    
                        <div className={style.errorMessage}>
                            {this.props.errorMessage}
                        </div>


                        {/* <div className={style.inputBox}>
                    <input type="text" onChange={this.props.onChange} value={this.props.value} name={this.props.name}/>
                </div> */}
                    </div>

                }

                {this.props.readOnly !== true &&

                    <div className={style.area}>
                        <div className={style.label}>
                            {this.props.label}
                        </div>

                        <input type="text" id={this.props.id} onChange={this.props.onChange} value={value} name={this.props.name} />

                        <div className={style.errorMessage}>
                            {this.props.errorMessage}
                        </div>


                        {/* <div className={style.inputBox}>
<input type="text" onChange={this.props.onChange} value={this.props.value} name={this.props.name}/>
</div> */}
                    </div>

                }

            </>



        );
    }
}
export default TextBoxWithLabel